import React, { useEffect, useRef } from "react";
import { Box, Typography, Container, useMediaQuery } from "@mui/material";
import { gsap } from "gsap";
import { ELEvations, gardientline, herobackgroundmobile, herosectiondesktopbackground, herosectionmobilebackground, kollawhitelogo, LandingBackground } from "../../../assets"; // Import images
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

const HeroSectionMain: React.FC = () => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const imageRef = useRef<HTMLImageElement | null>(null);
  const isMobile = useMediaQuery("(max-width: 600px)");

  useEffect(() => {
    gsap.fromTo(
      textRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1.2, ease: "power2.out" }
    );
    gsap.fromTo(
      imageRef.current,
      { opacity: 0, scale: 0.9 },
      { opacity: 1, scale: 1, duration: 1.5, ease: "power2.out", delay: 0.5 }
    );
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: isMobile ? "auto" : "100vh",
        backgroundImage: isMobile ? `url(${herosectionmobilebackground})` : `url(${herosectiondesktopbackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        px: { xs: 3, md: 5 },
        py: { xs: "100px", md: 0 },
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: "center",
          gap: { xs: 2, md: 0 },
        }}
      >
        {/* Left Side Content */}
        <Box
          sx={{
            width: isMobile ? "100%" : "35%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 2,
            position: "relative",
            height: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 0,
            }}
          >
            <Box component="img" src={kollawhitelogo} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group"
              sx={{
                height: isMobile ? "70px" : "70px",
                mb: 2,
                mt: 6,
              }}
            />
          </Box>
          {
            isMobile ?  
            <Box sx={{ position: "relative", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", }}>
              <img src={gardientline} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" style={{ position: "absolute", left: "-100%", top: "50%", transform: "translateY(-50%)", width: "580px", height: "auto" }} />
            </Box>
            : ""
          }

          {/* Luxury Text */}
          <Box ref={textRef} sx={{ color: "lightgrey" }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: "580",
                fontSize: { xs: "20px", md: "28px" },
                background: "linear-gradient(90deg, #bf742c, #fff8da, #c58038)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                display: "inline-block",
              }}
            >
              LUXURY AS RARE AS YOU ARE
            </Typography>

            {!isMobile &&
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 3,
                  textAlign: "center",
                  width: "100%",
                  gap: { xs: 2, md: 4 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontFamily: "'Lemon Milk', sans-serif !important",
                      fontSize: { xs: "24px", md: "30px" },
                      fontWeight: 100,
                    }}
                  >
                    2.5 & 3 BHK
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "14px",
                      mb: 1,
                      fontFamily: "'Lemon Milk', sans-serif !important",
                      fontWeight: 400,
                      opacity: 0.75,
                      mt: 0.5,
                    }}>
                    PREMIUM LIVING SPACES
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "center", position: "relative" }}>
                  <Box sx={{ height: "55px", width: isMobile ?"1.5px" : "2px", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", background: "linear-gradient(0deg, #bf742c, #fff8da, #c58038)", borderRadius: "5px" }} />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    position: "relative",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontFamily: "'Lemon Milk', sans-serif !important",
                      fontSize: { xs: "24px", md: "30px" },
                      fontWeight: 100,
                    }}
                  >
                    1510 - 1815
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "14px",
                      mb: 1,
                      fontFamily: "'Lemon Milk', sans-serif !important",
                      fontWeight: 400,
                      textAlign: "left",
                      opacity: 0.75,
                      mt: 0.5,
                    }}
                  >
                    SQ. FT
                  </Typography>
                </Box>
              </Box>
            }

            <Box
              sx={{
                my: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "left",
                width: "100%",
                position: "relative",
              }}
            >
               {isMobile ? "" : <img src={gardientline} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" style={{ width: "800px", height: "2px", position: 'absolute', top: '50%', left: '0%', transform: 'translate(-50%, -50%)' }} /> }
            </Box>

            {!isMobile &&
            <>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mt: 2 }}>
                <LocationOnOutlinedIcon sx={{ color: "lightgrey", fontSize: 30 }} />
                <Typography variant="body1" sx={{ fontSize: 18, color: "lightgrey", fontFamily: "'Lemon Milk', sans-serif !important", fontWeight: 400, letterSpacing: 1 }}>
                  Chanda Nagar, Hyderabad
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mt: 2 }}>
          
              <Typography variant="body1" sx={{ fontSize: "12px", opacity: 0.8 , fontFamily: "'Lemon Milk', sans-serif !important", fontWeight: 400, letterSpacing: 1, color: "#b5b5b5" }}>
                    Rera No: P01100009146
                  </Typography>
              </Box>
              </>
            }

          </Box>

        </Box>

        {/* Right Side - Apartment Image */}
        {!isMobile ?
          <Box
            ref={imageRef}
            sx={{
              position: "absolute",
              bottom: 0,
              right: 0,
              width: isMobile ? "100%" : "65%",
              height: "auto",
              borderRadius: 2,
            }}
          >
            <img src={ELEvations} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" style={{ width: "100%", height: "auto", borderRadius: "inherit" }} />
          </Box>
          :
          <>
            <Box
              ref={imageRef}
              sx={{
                width: "150%",
                height: "auto",
                borderRadius: 2,
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: "20px",
              }}
            >
              <img src={ELEvations} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" style={{ width: "100%", height: "auto", borderRadius: "inherit" }} />
            </Box>
          </>
        }

          {isMobile &&
          <>
            <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              mt: 3,
              textAlign: "center",
              width: "100%",
              gap: { xs: 2, md: 3 },
            }}
            >
            <Box
              sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              }}
            >
              <Typography
              variant="h4"
              sx={{
                fontFamily: "'Lemon Milk', sans-serif !important",
                fontSize: { xs: "20px", md: "24px" },
                fontWeight: 100,
                color: "lightgrey",
              }}
              >
              2.5 & 3 BHK
              </Typography>
              <Typography
              variant="body2"
              sx={{
                fontSize: "12px",
                mb: 1,
                fontFamily: "'Lemon Milk', sans-serif !important",
                fontWeight: 400,
                opacity: 0.75,
                mt: 0.5,
                color: "lightgrey",
              }}
              >
              PREMIUM LIVING SPACES
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center", position: "relative" }}>
              <Box sx={{ height: "55px", width: "1.5px", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", background: "linear-gradient(0deg, #bf742c, #fff8da, #c58038)", borderRadius: "5px" }} />
            </Box>

            <Box
              sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              position: "relative",
              }}
            >
              <Typography
              variant="h4"
              sx={{
                fontFamily: "'Lemon Milk', sans-serif !important",
                fontSize: { xs: "20px", md: "24px" },
                fontWeight: 100,
                color: "lightgrey",
              }}
              >
              1510 - 1815
              </Typography>
              <Typography
              variant="body2"
              sx={{
                fontSize: "12px",
                mb: 1,
                fontFamily: "'Lemon Milk', sans-serif !important",
                fontWeight: 400,
                textAlign: "left",
                opacity: 0.75,
                mt: 0.5,
                color: "lightgrey",
              }}
              >
              SQ. FT
              </Typography>
            </Box>
            </Box>
            
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mt: 2 }}>
              <LocationOnOutlinedIcon sx={{ color: "lightgrey", fontSize: 24 }} />
                <Typography variant="body1" sx={{ fontSize: "13px", fontFamily: "'Lemon Milk', sans-serif !important", fontWeight: 400, letterSpacing: 1, color: "lightgrey" }}>
                Chanda Nagar, Hyderabad
                </Typography>
            </Box>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mt: 0 }}>
                <Typography variant="body1" sx={{ fontSize: "11px", fontFamily: "'Lemon Milk', sans-serif !important", fontWeight: 400, letterSpacing: 1, color: "grey" }}>
                  Rera No: P01100009146
                </Typography>
              </Box>
            </>
          }

      </Container>
    </Box>
  );
};

export default HeroSectionMain;
